import React, { useState } from 'react';
import { Globe, TrendingUp, Users, MapPin, Star } from 'lucide-react';
import mapaImagen from '../assets/images/mapa.jpg';
import walmartLogo from '../assets/images/socios/walmart.png';
import comercialLogo from '../assets/images/socios/comercial.png';
import chedrauiLogo from '../assets/images/socios/chedraui.png';
import netoLogo from '../assets/images/socios/neto.png';
import sorianaLogo from '../assets/images/socios/soriana.png';
import tienda3b from '../assets/images/socios/3B_logo.svg.png';

const SociosComerciales = () => {
  const [activeClient, setActiveClient] = useState(0);
  
  const clientes = [
    { 
      name: "Walmart", 
      logo: walmartLogo,
      description: "Cadena de supermercados líder mundial",
      applyInvertFilter: true
    },    { 
      name: "Comercial Mexicana", 
      logo: comercialLogo,
      description: "Retail mexicano de tradición",
      applyInvertFilter: true
    },    { 
      name: "Chedraui", 
      logo: chedrauiLogo,
      description: "Cadena mexicana de supermercados",
      applyInvertFilter: true
    },
        {
      name: "Tienda 3B",
      logo: tienda3b, 
      description: "Supermercados de bajo costo con calidad garantizada",
      applyInvertFilter: true
    },
    { 
      name: "Neto", 
      logo: netoLogo,
      description: "Supermercados de proximidad",
      applyInvertFilter: true
    },
    { 
      name: "Soriana", 
      logo: sorianaLogo,
      description: "Una de las cadenas más importantes de México",
      applyInvertFilter: true
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section con diseño diagonal */}
      <div className="relative overflow-hidden">
        {/* Formas geométricas de fondo */}
        <div className="absolute top-0 left-0 w-72 h-72 bg-green-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-green-500/5 rounded-full blur-3xl"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20 lg:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div>
              <div className="inline-block p-3 bg-green-500/10 rounded-lg mb-6">
                <Users className="w-8 h-8 text-green-600" />
              </div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-gray-900 leading-tight mb-6">
                Socios
                <span className="block text-transparent bg-gradient-to-r from-green-600 to-green-400 bg-clip-text">
                  Comerciales
                </span>
              </h1>
              <p className="text-lg sm:text-xl text-gray-700 mb-8 leading-relaxed">
                Construimos alianzas estratégicas que transforman el sector alimentario 
                a través de la innovación, calidad y excelencia operacional.
              </p>
              <div className="flex flex-wrap items-center space-x-4">
                <div className="flex items-center space-x-2 text-gray-900 mb-2 sm:mb-0">
                  <Star className="w-5 h-5 fill-current text-green-600" />
                  <span className="font-semibold">Calidad Premium</span>
                </div>
                <div className="flex items-center space-x-2 text-gray-900 mb-2 sm:mb-0">
                  <Globe className="w-5 h-5 text-green-600" />
                  <span className="font-semibold">Alcance Global</span>
                </div>
              </div>
            </div>
            {/* Mapa con overlay moderno */}
            <div className="relative mt-10 lg:mt-0">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl transform rotate-0 sm:rotate-3 hover:rotate-0 transition-transform duration-500">
                <img
                  src={mapaImagen}
                  alt="Mapa de cobertura comercial"
                  className="w-full h-56 sm:h-80 object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-green-500/10 to-green-500/10"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-center text-gray-900">
                    <MapPin className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-3 animate-pulse text-green-600" />
                    <h3 className="text-xl sm:text-2xl font-bold">Presencia Global</h3>
                  </div>
                </div>
              </div>
              {/* Tarjetas flotantes de cobertura */}
              <div className="absolute -bottom-4 sm:-bottom-6 -left-2 sm:-left-6 bg-white/80 backdrop-blur-lg rounded-2xl p-3 sm:p-4 border border-green-200">
                <div className="flex items-center space-x-2 sm:space-x-3">
                  <TrendingUp className="w-5 h-5 sm:w-6 sm:h-6 text-green-600" />
                  <div>
                    <p className="text-gray-900 font-semibold text-sm sm:text-base">Importación</p>
                  </div>
                </div>
              </div>
              <div className="absolute -top-4 sm:-top-6 -right-2 sm:-right-6 bg-white/80 backdrop-blur-lg rounded-2xl p-3 sm:p-4 border border-green-200">
                <div className="flex items-center space-x-2 sm:space-x-3">
                  <Globe className="w-5 h-5 sm:w-6 sm:h-6 text-green-600" />
                  <div>
                    <p className="text-gray-900 font-semibold text-sm sm:text-base">Exportación</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Sección de clientes con diseño de carrusel interactivo */}
      <div className="relative py-12 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-gray-900 mb-4">
              Nuestros <span className="text-transparent bg-gradient-to-r from-green-600 to-green-400 bg-clip-text">Aliados</span>
            </h2>
            <p className="text-lg sm:text-xl text-gray-700 max-w-3xl mx-auto">
              Empresas visionarias que confían en nuestra propuesta de valor único
            </p>
          </div>
          {/* Cliente destacado grande */}
          <div className="mb-10 sm:mb-16">
            <div className="bg-white/80 backdrop-blur-lg rounded-3xl p-4 sm:p-8 border border-green-100 hover:border-green-400 transition-all duration-300">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8 items-center">
                <div className="lg:col-span-1 mb-4 lg:mb-0">
                  <img
                    src={clientes[activeClient].logo}
                    alt={clientes[activeClient].name}
                    className="w-32 h-16 sm:w-full sm:h-24 object-contain mx-auto filter grayscale"
                  />
                </div>
                <div className="lg:col-span-2">
                  <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
                    {clientes[activeClient].name}
                  </h3>
                  <p className="text-gray-700 text-base sm:text-lg mb-4">
                    {clientes[activeClient].description}
                  </p>
                  <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-green-500 to-green-400 rounded-full text-white font-semibold text-sm sm:text-base">
                    <Star className="w-4 h-4 mr-2" />
                    Socio Estratégico
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Grid de clientes en miniatura */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 sm:gap-6">
            {clientes.map((cliente, index) => (
              <div
                key={index}
                onClick={() => setActiveClient(index)}
                className={`
                  relative group cursor-pointer transition-all duration-300 transform hover:scale-105
                  ${activeClient === index ? 'scale-105' : 'scale-100 opacity-60 hover:opacity-80'}
                `}
              >
                <div className={`
                  bg-white/80 backdrop-blur-lg rounded-2xl p-3 sm:p-6 border transition-all duration-300
                  ${activeClient === index 
                    ? 'border-green-400 shadow-lg shadow-green-200/25' 
                    : 'border-green-100 hover:border-green-200'
                  }
                `}>
                  <img
                    src={cliente.logo}
                    alt={cliente.name}
                    className="w-16 h-8 sm:w-full sm:h-16 object-contain filter grayscale"
                  />
                  {activeClient === index && (
                    <div className="absolute -top-2 -right-2 w-4 h-4 bg-green-500 rounded-full animate-ping"></div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SociosComerciales;